import React, { useCallback, useState } from 'react';

import { FormFieldProps, GetFieldValidatorFn } from 'types';

import { TextField } from './TextField';
import { getTCommon, useTFeature } from '../fields.utils';
import { getBaseFieldValidator } from '../form.validators';

const REQUIRED_LENGTH = 4;

export const Field: React.FC<FormFieldProps> = ({
  field: { name, value },
  autoFocus,
  onChange,
}) => {
  const { t } = useTFeature();

  const [localValue, setLocalValue] = useState(value);

  const handleChange = useCallback(
    (value: string) => {
      if (!onChange || value?.length > REQUIRED_LENGTH) {
        return;
      }
      const numericValue = value.replace(/[^0-9#]/g, '');
      setLocalValue(numericValue);
      onChange(numericValue?.length === REQUIRED_LENGTH ? numericValue : '');
    },
    [onChange],
  );

  return (
    <TextField
      name={name}
      value={localValue}
      placeholder={t('fields.last_phone_digits.placeholder')}
      autoFocus={autoFocus}
      onChange={handleChange}
    />
  );
};

export const getValidator: GetFieldValidatorFn = ({ required }) => {
  const tCommon = getTCommon();
  return getBaseFieldValidator({ required }).matches(
    /^[0-9]{4}$/,
    tCommon('errors.invalid'),
  );
};
